export const referencesListFilter = (): void => {
  const allReferenceBlocks = document.querySelectorAll('.js-referencesList') as unknown as HTMLElement[]

  allReferenceBlocks.forEach((referenceBlock: HTMLElement) => {
    const allFilterTrigers = referenceBlock.querySelectorAll('.js-referencesList-soloTagFilter') as unknown as HTMLElement[]

    allFilterTrigers.forEach((triggerElement: HTMLElement) => {
      triggerElement.addEventListener('click', (e: Event): void => {
        const allReferences = referenceBlock.querySelectorAll('.js-referencesList-singleReference') as unknown as HTMLElement[]

        const filterValue = triggerElement.dataset.filterTarget as unknown as string

        allReferences.forEach((reference: HTMLElement) => {
          // @ts-ignore
          const tagIDS = JSON.parse(reference.dataset.singleReferenceTags)
          const stringTags: string[] = tagIDS.map((tagID: number) => {
            return tagID.toString()
          })
          if (stringTags.includes(filterValue) || filterValue === 'all') {
            reference.style.display = 'block'
          }
          else {
            reference.style.display = 'none'
          }
        })

        allFilterTrigers.forEach((tagElement: HTMLElement) => {
          tagElement.classList.remove('-active')
        })
        triggerElement.classList.add('-active')
      })
    })
  })
}
